/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HandbookCategoryDetails = {
    properties: {
        handbookCategory: {
    type: 'HandbookCategory',
    isRequired: true,
},
        subcategories: {
    type: 'array',
    contains: {
        type: 'HandbookSubCategory',
    },
    isRequired: true,
},
        handbooks: {
    type: 'array',
    contains: {
        type: 'Handbook',
    },
    isRequired: true,
},
    },
};